<template>
    <div class="text-center text-lg md:text-xl text-neutral-500">
        <slot />
    </div>
</template>
